import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule, MatListModule, CommonModule, RouterModule],
})
export class NavigationComponent {
  private authService = inject(AuthService);

  public vm$ = combineLatest([
    this.authService.platformUser$,
    this.authService.moduleTabs$,
  ]).pipe(
    map(([portalUser, moduleTabs]) => ({
      portalUser,
      moduleTabs: moduleTabs
        .sort((a, b) => a.label.localeCompare(b.label)) // sort tabs alphabetically by label
        .map((moduleTab) => ({
          ...moduleTab,
          tiles: moduleTab.tiles.sort(
            // sort tiles alphabetically by name
            (a, b) => a.name.localeCompare(b.name),
          ),
        })),
    })),
  );
}
